import {
    CheckoutSessionCreationV2,
    CheckoutSessionV2,
    CustomerSessionCreationV2,
    CustomerSessionV2,
} from '../../model/v2/EntitiesV2';
import apiAxiosV2 from './CustomAxiosV2';

class PaymentApiV2 {
    createCheckoutSession = async (checkoutSessionCreation: CheckoutSessionCreationV2): Promise<CheckoutSessionV2> => {
        const response = await apiAxiosV2.post<CheckoutSessionV2>(
            '/payments/checkout-sessions',
            checkoutSessionCreation,
        );

        return response.data;
    };

    createCustomerSession = async (customerSessionCreation: CustomerSessionCreationV2): Promise<CustomerSessionV2> => {
        const response = await apiAxiosV2.post<CustomerSessionV2>(
            '/payments/customer-sessions',
            customerSessionCreation,
        );

        return response.data;
    };
}

const paymentApiV2: PaymentApiV2 = new PaymentApiV2();
export default paymentApiV2;
